"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tickMillis = exports.reducer = exports.makeInitialState = exports.getPowerConsumption = exports.DeviceServer = exports.createVirtualDevices = void 0;
var device_1 = require("./device");
Object.defineProperty(exports, "createVirtualDevices", { enumerable: true, get: function () { return device_1.createVirtualDevices; } });
Object.defineProperty(exports, "DeviceServer", { enumerable: true, get: function () { return device_1.DeviceServer; } });
__exportStar(require("./interfaces/action"), exports);
__exportStar(require("./interfaces/message"), exports);
__exportStar(require("./interfaces/state"), exports);
var reducer_1 = require("./reducer");
Object.defineProperty(exports, "getPowerConsumption", { enumerable: true, get: function () { return reducer_1.getPowerConsumption; } });
Object.defineProperty(exports, "makeInitialState", { enumerable: true, get: function () { return reducer_1.makeInitialState; } });
Object.defineProperty(exports, "reducer", { enumerable: true, get: function () { return reducer_1.reducer; } });
Object.defineProperty(exports, "tickMillis", { enumerable: true, get: function () { return reducer_1.tickMillis; } });
__exportStar(require("./selectors"), exports);
__exportStar(require("./util"), exports);
